import "core-js/modules/es.array.concat.js";
import cookies from './util.cookies';
import db from './util.db';
import log from './util.log';
import date from './util.date';
import elementResizeDetectorMaker from 'element-resize-detector';
var util = {
  cookies: cookies,
  db: db,
  log: log,
  date: date
};
/**
 * @description 更新标题
 * @param {String} title 标题
 */

util.title = function (titleText) {
  var processTitle = process.env.VUE_APP_TITLE || 'U8SDK';
  window.document.title = "".concat(processTitle).concat(titleText ? " | ".concat(titleText) : '');
};
/**
 * @description 打开新页面
 * @param {String} url 地址
 */


util.open = function (url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', 'u8admin-link-temp');
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(document.getElementById('u8admin-link-temp'));
};
/**
 * 根据屏幕宽度，调整dialog的宽度
 */


util.ajustDialogWidth = function () {
  var screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
  var dialogWidth = '50%';

  if (screenWidth <= 1230) {
    dialogWidth = '70%';
  } else if (screenWidth <= 1430) {
    dialogWidth = '60%';
  } else {
    dialogWidth = '50%';
  }

  return dialogWidth;
};
/**
 * 根据屏幕宽度，调整宽度
 */


util.ajustBaseWidth = function (baseWidthPercent) {
  var screenWidth = document.documentElement.clientWidth || document.body.clientWidth;
  var dialogWidth = baseWidthPercent;

  if (screenWidth <= 1230) {
    dialogWidth = baseWidthPercent + 20;
  } else if (screenWidth <= 1430) {
    dialogWidth = baseWidthPercent + 10;
  } else {
    dialogWidth = baseWidthPercent;
  }

  return dialogWidth + '%';
};

util.listenElementResize = function (elementObj, resizeCallback) {
  var erd = elementResizeDetectorMaker({
    strategy: "scroll"
  });
  erd.listenTo(elementObj, function (element) {
    if (resizeCallback) {
      resizeCallback(element);
    }
  });
};

util.getApiUrl = function () {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_API;
  }

  var G = window.g;
  return G ? G.url || process.env.VUE_APP_API : process.env.VUE_APP_API;
};

export default util;